/*
 * Accordion
 *
 * Based on https://inclusive-components.design/collapsible-sections/
 */

'use-strict';

class Accordion {
  constructor(headingSelector = '.js-accordion-heading') {
    // Get all of the headings
    const headings = document.querySelectorAll(headingSelector);

    Array.prototype.forEach.call(headings, (heading) => {
      // Give each heading a toggle button child
      heading.innerHTML = `
        <button aria-expanded="false" class="accordion__button">
          <span>${heading.textContent}</span>
          <svg width="21" height="13" viewBox="0 0 21 13" xmlns="http://www.w3.org/2000/svg"><path d="M2 1l8.5 9L19 1" stroke="currentColor" stroke-width="3" fill="none" fill-rule="evenodd"/></svg>
        </button>
      `;

      // Get the content element
      const wrapper = heading.nextElementSibling;
      wrapper.hidden = true;

      // Assign the button
      let btn = heading.querySelector('button');

      btn.onclick = () => {
        // Cast the state as a boolean
        let expanded = btn.getAttribute('aria-expanded') === 'true' || false;

        // Switch the state
        btn.setAttribute('aria-expanded', !expanded);
        // Switch the content's visibility
        wrapper.hidden = expanded;
      };
    });
  }
}

export default Accordion;
